module.exports = __webpack_public_path__ + "img/nepa.5da32e82.jpg";